import { Link } from 'react-router-dom';
import { RxNormRelationship, RxNormRelationshipType } from '../../types/code.types';

interface RxNormRelationshipsProps {
  relationships: RxNormRelationship[];
  codeType: string;
}

const RELATIONSHIP_LABELS: Record<RxNormRelationshipType, string> = {
  has_ingredient: 'Active Ingredient',
  has_brand_name: 'Brand Name',
  has_generic_equivalent: 'Generic Equivalent',
  has_branded_equivalent: 'Branded Equivalent',
};

const RxNormRelationships = ({ relationships, codeType }: RxNormRelationshipsProps) => {
  if (relationships.length === 0) return null;
  const groups = relationships.reduce<Record<string, RxNormRelationship[]>>((acc, rel) => {
    acc[rel.relationship] = acc[rel.relationship] || [];
    acc[rel.relationship].push(rel);
    return acc;
  }, {});
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">🔗 Drug Relationships</h2>
      <div className="space-y-6">
        {Object.entries(groups).map(([type, items]) => (
          <div key={type}>
            <h3 className="text-lg font-bold text-primary-700 mb-3">{RELATIONSHIP_LABELS[type as RxNormRelationshipType] || type}</h3>
            <div className="flex flex-wrap gap-2">
              {items.map((item, index) => (
                <Link
                  key={`${item.rxCUI}-${index}`}
                  to={`/code/${codeType}/${item.rxCUI}`}
                  className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg text-sm text-gray-800 hover:bg-gray-100 hover:text-primary-700 transition-colors"
                >
                  <span>{item.name}</span>
                  <span className="px-2 py-0.5 bg-primary-50 text-primary-700 rounded-full text-xs font-medium">{item.tty}</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RxNormRelationships;
